<template>
  <div>
    <b-card :title="$t('users.form.accountInfo')">
      <b-row>
        <b-col
          cols="12"
          md="6"
        >
          <user-name />
        </b-col>
        <b-col
          cols="12"
          md="6"
        >
          <user-email />
        </b-col>
        <b-col
          cols="12"
          md="6"
        ><user-type /></b-col>
        <b-col
          cols="12"
          md="6"
        ><user-status /></b-col>
      </b-row>
    </b-card>
    <b-card :title="$t('users.form.accountSecurity')">
      <user-password />
    </b-card>
  </div>
</template>

<script>
import { BCard, BRow, BCol } from 'bootstrap-vue'
import UserName from '@/views/Users/elements/UserName.vue'
import UserEmail from '@/views/Users/elements/UserEmail.vue'
import UserPassword from '@/views/Users/elements/UserPassword.vue'
import UserType from '@/views/Users/elements/UserType.vue'
import UserStatus from '@/views/Users/elements/UserStatus.vue'

export default {
  name: 'UserForm',
  components: {
    BCard,
    BRow,
    BCol,
    UserName,
    UserEmail,
    UserPassword,
    UserType,
    UserStatus,
  },
}
</script>
